export default __webpack_public_path__ + "static/media/rom-coach-logo-web.c12fa575.png";